module.exports = __webpack_public_path__ + "static/img/nksjk.5f11041.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/nksjk.jpg
// module id = MXGy
// module chunks = 21